import {
  ChangeSortingOfReportingForInstagramPostsOrTikTokVideosEventLabel,
  ChangeSortingOfReportingForInstagramPostsUserAction,
  ChangeSortingOfReportingForInstagramReelsEventLabel,
  ChangeSortingOfReportingForInstagramReelsUserAction,
  ChangeSortingOfReportingForInstagramStoriesEventLabel,
  ChangeSortingOfReportingForInstagramStoriesUserAction,
  ChangeSortingOfReportingForTikTokVideosUserAction,
  DownloadExcelReportV2UserAction,
  ShowStatDetailsForOfContentCardUserAction,
  UserAction
} from '../../types/user-actions';

export const isChangeSortingOfReportingForInstagramPostsUserAction = (
  action?: UserAction
): action is ChangeSortingOfReportingForInstagramPostsUserAction => (
  action !== undefined && action.eventCategory === 'instagram posts reporting'
  && action.eventAction === 'change sorting'
);

export const getChangeSortingOfReportingForInstagramPostsOrTikTokVideosEventLabel = (
  sortingType: string
): ChangeSortingOfReportingForInstagramPostsOrTikTokVideosEventLabel => {
  switch (sortingType) {
    case 'total_reactions':
      return 'total reaction';
    case 'impressions':
      return 'impressions';
    case 'engagement_rate':
      return 'engagement rate';
    default:
      throw new Error('Unexpected sorting type selected. Potentially corrupt data for GA.');
  }
};

export const isChangeSortingOfReportingForTikTokVideosUserAction = (
  action?: UserAction
): action is ChangeSortingOfReportingForTikTokVideosUserAction => (
  action !== undefined && action.eventCategory === 'tiktok videos reporting'
  && action.eventAction === 'change sorting'
);

export const getChangeSortingOfReportingForInstagramStoriesEventLabel = (
  sortingType: string
): ChangeSortingOfReportingForInstagramStoriesEventLabel => {
  switch (sortingType) {
    case 'total_reactions':
      return 'total reaction';
    case 'engagement_rate':
      return 'engagement rate';
    default:
      throw new Error('Unexpected sorting type selected. Potentially corrupt data for GA.');
  }
};

export const getChangeSortingOfReportingForInstagramReelsEventLabel = (
  sortingType: string
): ChangeSortingOfReportingForInstagramReelsEventLabel => {
  switch (sortingType) {
    case 'total_reactions':
      return 'total reaction';
    case 'engagement_rate':
      return 'engagement rate';
    case 'impressions':
      return 'impressions';
    default:
      throw new Error('Unexpected sorting type selected. Potentially corrupt data for GA.');
  }
};

export const isChangeSortingOfReportingForInstagramReelsUserAction = (
  action?: UserAction
): action is ChangeSortingOfReportingForInstagramReelsUserAction => (
  action !== undefined && action.eventCategory === 'instagram reels reporting'
  && action.eventAction === 'change sorting'
);

export const isChangeSortingOfReportingForInstagramStoriesUserAction = (
  action?: UserAction
): action is ChangeSortingOfReportingForInstagramStoriesUserAction => (
  action !== undefined && action.eventCategory === 'instagram stories reporting'
  && action.eventAction === 'change sorting'
);

export const isShowStatDetailsForOfContentCardUserAction = (
  action?: UserAction
): action is ShowStatDetailsForOfContentCardUserAction => (
  action !== undefined && action.eventCategory === 'content card'
  && action.eventAction === 'show details'
);

export const isDownloadExcelReportV2UserAction = (
  action?: UserAction
): action is DownloadExcelReportV2UserAction => (
  action !== undefined && action.eventCategory === 'v2 reporting'
  && action.eventAction === 'download excel'
);
